import React from 'react';
import { motion } from 'framer-motion';
import { fireAddToCart } from '../../hooks/useMetaPixel';
interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'accent';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  href
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 shadow-md hover:shadow-lg z-10 relative';
  const variants = {
    primary: 'bg-partyPink-hot text-white hover:bg-pink-600 hover:shadow-glow',
    secondary: 'bg-white text-partyPink-hot border-2 border-partyPink-hot hover:bg-partyPink-light',
    accent: 'bg-mint-dark text-white hover:bg-teal-500'
  };
  const sizes = {
    sm: 'px-6 py-2 text-sm',
    md: 'px-8 py-3 text-base',
    lg: 'px-12 py-5 text-xl md:text-2xl uppercase tracking-wider'
  };
  const isCheckout = !!href;
  const handleClick = (e: React.MouseEvent) => {
    if (isCheckout) {
      fireAddToCart();
    } else {
      e.preventDefault();
      const el = document.getElementById('pricing');
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.a href={href || '#pricing'} target={isCheckout ? '_blank' : undefined} rel={isCheckout ? 'noopener noreferrer' : undefined} onClick={handleClick} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className} cursor-pointer no-underline`} data-id="element-237">
      {children}
    </motion.a>;
}